import { AlertModal } from "BEDROCK/shared-components/alert-modal";
import { useEffect, useState } from "react";
import styles from "./draft-alert-modal.module.css";
import { useProjectStore } from "entity-store/project-store/use-project-store";

interface DraftAlertModalProps {
  title: string;
  message: string;
  cancelCTA: string;
  overrideCTA: string;

  currentProjectID?: string;
  canShow: boolean;
  onOverride: () => void;
  onCancel: () => void;
}

export const DraftAlertModal = (props: DraftAlertModalProps) => {
  const [isShowing, setIsShowing] = useState(false);
  const { projects, deleteProject } = useProjectStore();

  useEffect(() => {
    showIfNecessary();
  }, [props.canShow]);

  const firstProject = projects?.filter(
    (p) =>
      p.isInCheckout === false &&
      p.isOrdered === false &&
      p.id !== props.currentProjectID
  )[0];

  const showIfNecessary = () => {
    if (!props.canShow) {
      return;
    }
    if (firstProject) {
      setIsShowing(true);
    } else {
      props.onOverride();
    }
  };

  const overridePreviousDraft = () => {
    setIsShowing(false);
    if (firstProject) {
      deleteProject(firstProject);
    }
    props.onOverride();
  };

  const continuePreviousDraft = () => {
    setIsShowing(false);
    let projectID = firstProject?.id;
    if (!projectID) {
      return;
    }
    //Navigating to the same page with a different project ID is apparently
    //rocket surgery.
    window.location.href = `/project/${projectID}`;
  };

  return (
    <AlertModal
      className={styles.alertContainer}
      title={props.title}
      message={props.message}
      isShowing={isShowing}
      proceedCTA={props.overrideCTA}
      dismissCTA={props.cancelCTA}
      ctaArrangement="VERTICAL"
      onProceed={overridePreviousDraft}
      onDismiss={continuePreviousDraft}
    />
  );
};
